module.exports = __webpack_public_path__ + "static/practice-01-cover-380ed1dc6209014241b5474bb4794daa.jpg";